import { useCallback, useState } from 'react';

export function useImageFallback(src: string | null | undefined) {
  const [hasError, setHasError] = useState(false);
  const [prevSrc, setPrevSrc] = useState(src);

  if (prevSrc !== src) {
    setPrevSrc(src);
    setHasError(false);
  }

  const onError = useCallback(() => {
    setHasError(true);
  }, []);

  const reset = useCallback(() => {
    setHasError(false);
  }, []);

  return { hasError, onError, reset };
}
